import React, { Component } from "react";
import { connect } from "react-redux";
import "./content.scss";
import searchIcon from "../../../assets/svg/searchBlue.svg";
import { Link } from "react-router-dom";
import { configure_progress, gettingStartedProgress } from "../../../actions/globalAction";
import searchImg from "../../../assets/search.png";
import { Dimmer, Loader } from "semantic-ui-react";
import { setActiveModule } from "../../../actions/sideBarActions";
class ExploreSearch extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
        if (this.props.packageObj?.package_code !== "enterprise") {
            this.props.configure_progress("explore_search", this.props.total_fields);
        }
    }

    configureProgress = () => {
        localStorage.setItem("activeModule", "Listening");
        this.props.configure_progress("explore_search", this.props.total_fields);
        this.props.setModule("Listening");
    };

    render() {
        return (
            <>
                <div className="gs_content">
                    <div className="left_content">
                        <div className="gs_header">
                            <img src={searchIcon} color="#268af6" className="icon_content" />
                            <span className="content_title"> Search</span>
                        </div>
                        <div className="text_content">
                            <p>{`This is like your familiar Google search.  It works on social data, though!`} </p>
                            <p>{`Isn’t that exciting :-) `} </p>
                            <p>{`Just enter any word or phrase and we will search through billions of social media conversations from hundreds of social networks (both global and local) including news, blogs and forums to show you the most recent conversations.`}</p>
                            <p>{`You will be able to view conversations as well as Analytics around those conversations.`}</p>
                        </div>
                        {this.props.packageObj?.package_code == "enterprise" ? (
                            <Link to="/search">
                                <button className="gs_link" onClick={() => this.configureProgress()}>
                                    Search
                                </button>
                            </Link>
                        ) : (
                            <div className="no__access__info">*Available in Enterprise package only</div>
                        )}
                    </div>
                    <div className="right_content">
                        <div id="gs_loader">
                            <Dimmer inverted active>
                                <Loader size="big skiptranslate">Loading</Loader>
                            </Dimmer>
                        </div>
                        <iframe
                            width="320px"
                            height="200px"
                            src="https://www.youtube.com/embed/O1fzm9_1L1Q?modestbranding=1"
                            title=""
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; gyroscope; picture-in-picture"
                            allowFullScreen
                            onLoad={() => (document.getElementById("gs_loader").style.display = "none")}
                            className="content_video"></iframe>

                        {/* <img className="content-img" src={searchImg} width="350px" height="200px" /> */}
                    </div>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        packageObj: state.globalReducer.packageObj,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        configure_progress: (field, total) => dispatch(configure_progress(field, total)),
        gettingStartedProgress: () => dispatch(gettingStartedProgress()),
        setModule: (data) => dispatch(setActiveModule(data)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(ExploreSearch);
